"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cryptos = [
    {
        crypto: "BTC",
        network: "BTC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 105.0,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/BTC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "ETH",
        network: "ARBITRUM",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 26.25,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/ETH.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "ETH",
        network: "BSC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 26.25,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/ETH.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "ETH",
        network: "ETH",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 26.25,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/ETH.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "BSC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 1.05,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "ETH",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 10.5,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "MATIC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "TRX",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 2.1,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "XLM",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "ALGO",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "ARBITRUM",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 2.1,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "MAPO",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "PlatON",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "SUI",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 1.05,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDC",
        network: "FTM",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 2.1,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDC.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "BNB",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "BSC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 1.05,
        maxPurchaseAmount: 1900.0,
        address: "0x55d398326f99059ff775485246999027b3197955",
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "ETH",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 10.5,
        maxPurchaseAmount: 1900.0,
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "SOL",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "MATIC",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "ARBITRUM",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "TRX",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 3.15,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "PlatON",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.75,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "USDT",
        network: "SUI",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 1.05,
        maxPurchaseAmount: 1900.0,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/USDT.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
    {
        crypto: "VERSE",
        network: "ETH",
        buyEnable: 1,
        sellEnable: 0,
        minPurchaseAmount: 15.00,
        maxPurchaseAmount: 2000.00,
        address: null,
        icon: "https://static.alchemypay.org/alchemypay/crypto-images/verse.png",
        minSellAmount: null,
        maxSellAmount: null,
    },
];
exports.default = cryptos;
//# sourceMappingURL=cryptos.js.map